module.exports = __webpack_public_path__ + "static/media/pg_ph_charts_obtained.ad13248c.png";